
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38 5.6c0 4.1.5 6.3 2 8.1l2 2.6V4h30v24h24v52H81c-14.3 0-15 .1-15 2s.7 2 17 2h17V25.5L87.2 12.7 74.5 0H38v5.6zm47 9.9l8.5 8.5H76v-8.5c0-4.7.1-8.5.3-8.5.1 0 4 3.8 8.7 8.5z"}}),_c('path',{attrs:{"d":"M0 58v42h62V41.5L49.2 28.7 36.5 16H0v42zm34-26v12h24v52H4V20h30v12zm13-.5l8.5 8.5H38v-8.5c0-4.7.1-8.5.3-8.5.1 0 4 3.8 8.7 8.5z"}})])
          )
        }
      }
    